<div nxLayout="grid maxwidth" *ngIf="claims">
    <div nxRow>
        <div nxCol="12" class="docs-grid-colored-col claims">
            <div class="my-claims">
                <!-- heading with link -->
                <div class="heading">
                    <div class="heading-content">
                        <h3 nxHeadline="subsection-medium" translate class="title">claim.my-claims</h3>
                        <a [routerLink]="['/nove-hlasenie']" *ngIf="claims!==undefined&&claims.length>0">
                            <button nxPlainButton type="button" class="file-a-claim">
                                {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                    class="nx-margin-left-2xs"></nx-icon>
                            </button>
                        </a>
                    </div>
                    <div class="heading-tabs">
                        <cpc-tab-selector-group>
                            <cpc-tab-selector *ngFor="let content of ['open', 'closed']; let i = index"
                                [selected]="selectedIndex === i" (click)="tabChanged(i)">
                                {{ 'product-state.'+content | translate }}
                            </cpc-tab-selector>
                        </cpc-tab-selector-group>
                    </div>
                </div>
                <div class="heading-anchor-tiny">
                    <a [routerLink]="['/nove-hlasenie']" *ngIf="claims!==undefined&&claims.length>0">
                        <button nxPlainButton type="button" class="file-a-claim">
                            {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                class="nx-margin-left-2xs"></nx-icon>
                        </button>
                    </a>
                </div>



                <div *ngIf="selectedIndex==0">
                    <div nxRow class="tab-content" *ngIf="claims!==undefined&&claims.length>0">
                        <ng-template ngFor let-claim="$implicit" [ngForOf]="claims">
                            <div nxCol="12, 12, 12, 6, 4" class="claimColumn">
                                <app-claim-card [claim]="claim" [claimState]="claimStates.active"></app-claim-card>
                            </div>
                        </ng-template>
                    </div>
                    <div nxRow class="tab-content" *ngIf="claims!==undefined&&claims.length==0">
                        <div nxCol="12">
                            <div class="empty">
                                <div class="empty-content">
                                    <h3 nxHeadline="subsection-medium" translate>claim.empty-open.headline</h3>
                                    <p translate>claim.empty-open.text</p>
                                    <a [routerLink]="['/nove-hlasenie']">
                                        <button nxPlainButton type="button" class="file-a-claim">
                                            {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                                class="nx-margin-left-2xs"></nx-icon>
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="selectedIndex==1">
                    <div nxRow class="tab-content" *ngIf="claimsPast!==undefined&&claimsPast.length>0">
                        <ng-template ngFor let-claim="$implicit" [ngForOf]="claimsPast">
                            <div nxCol="12, 12, 12, 6, 4" class="claimColumn">
                                <app-claim-card [claim]="claim" [claimState]="claimStates.past"></app-claim-card>
                            </div>
                        </ng-template>
                    </div>
                    <div nxRow class="tab-content" *ngIf="claimsPast!==undefined&&claimsPast.length==0">
                        <div nxCol="12">
                            <div class="empty">
                                <div class="empty-content">
                                    <h3 nxHeadline="subsection-medium" translate>claim.empty-closed.headline</h3>
                                    <p translate>claim.empty-closed.text</p>
                                    <a [routerLink]="['/nove-hlasenie']">
                                        <button nxPlainButton type="button" class="file-a-claim">
                                            {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                                class="nx-margin-left-2xs"></nx-icon>
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- tab switcher with claim cards -->
                <!--<nx-tab-group (selectedTabChange)="tabChanged($event)">
                    <nx-tab [label]="'product-state.open' | translate">
                        <div nxRow class="tab-content" *ngIf="claims!==undefined&&claims.length>0">
                            <ng-template ngFor let-claim="$implicit" [ngForOf]="claims" >
                                <div nxCol="12, 12, 12, 6, 4" class="claimColumn">
                                    <app-claim-card [claim]="claim" [claimState]="claimStates.active"></app-claim-card>
                                </div>
                            </ng-template>
                        </div>
                        <div nxRow class="tab-content" *ngIf="claims!==undefined&&claims.length==0">
                            <div nxCol="12">
                                <div class="empty">
                                    <div class="empty-content">
                                    <h3 nxHeadline="subsection-medium" translate>claim.empty-open.headline</h3>
                                    <p translate>claim.empty-open.text</p>
                                    <a [routerLink]="['/nove-hlasenie']">
                                        <button nxPlainButton type="button" class="file-a-claim">
                                            {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                                class="nx-margin-left-2xs"></nx-icon>
                                        </button>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    </nx-tab>

                    <nx-tab [label]="'product-state.closed' | translate">
                        <div nxRow class="tab-content" *ngIf="claimsPast!==undefined&&claimsPast.length>0">
                            <ng-template ngFor let-claim="$implicit" [ngForOf]="claimsPast">
                                <div nxCol="12, 12, 12, 6, 4" class="claimColumn">
                                    <app-claim-card [claim]="claim" [claimState]="claimStates.past"></app-claim-card>
                                </div>
                            </ng-template>
                        </div>
                        <div nxRow class="tab-content" *ngIf="claimsPast!==undefined&&claimsPast.length==0">
                            <div nxCol="12">
                                <div class="empty">
                                    <div class="empty-content">
                                    <h3 nxHeadline="subsection-medium" translate>claim.empty-closed.headline</h3>
                                    <p translate>claim.empty-closed.text</p>
                                    <a [routerLink]="['/nove-hlasenie']">
                                        <button nxPlainButton type="button" class="file-a-claim">
                                            {{'claim.file-a-new-claim' | translate}}<nx-icon name="launch"
                                                class="nx-margin-left-2xs"></nx-icon>
                                        </button>
                                    </a>
                                </div>
                                </div>
                            </div>
                        </div>
                    </nx-tab>

                </nx-tab-group>-->


            </div>
        </div>
    </div>
</div>
